import React, { FC, useState } from 'react'

type Props = {
  request: () => Promise<string>
  fileName: string
  className?: string;
  label?: string;
}

const ExportCsvButton: FC<Props> = ({ request, fileName, className, label }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const format = 'csv'

  return (
    <button
      type="button"
      className={className || 'btn btn-sm btn-info'}
      disabled={isLoading}
        
      onClick={ async () => {
        setIsLoading(true)
        const data = await request()
        const blob = new Blob([data], {type: `text/${format}`})
        const a = document.createElement('a')

        a.href = URL.createObjectURL(blob)
        a.download = `${fileName}.${format}`
        a.click()
        setIsLoading(false)
      }}
    >
      <span className='indicator-label'>
        {label || 'Export to CSV'}
      </span>
      {(isLoading) && (
        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
      )}
    </button>
  )
}

export {ExportCsvButton}
